module.exports = __webpack_public_path__ + "static/yachtsafe-caseimg-83a8c887f04d12db5e7b7ee9b3185b47.jpg";